module.exports = __webpack_public_path__ + "img/logo2.763af74f.png";